export default "__VITE_ASSET__DlRxEjxZ__"